export default __webpack_public_path__ + "images/0x38d11b40d2173009adb245b869e90525950ae345.png";